import OrderReport from '../Features/SalesDep/Orders/OrderReport';
import { ordersUrl } from '../shared/baseUrl';

const Orders = () => {
    return (
        <div>
            <OrderReport />
        </div>
    )
}

export default Orders;